import { Observable } from "rxjs";

export default class Entity {
    constructor(data) {
        this.attributeKeys = [];
        this.subscribers = [];

        for (const key in data) {
            this[key] = data[key];
            this.attributeKeys.push(key);
        }
    }

    get(attributeName) {
        return this[attributeName];
    }

    set(attributeName, value) {
        this[attributeName] = value;
    }

    toJSON() {
        const json = {};

        for (const key of this.attributeKeys) {
            const value = this[key];
            if (value != undefined) {
                json[key] = this[key];
            }
        }

        return JSON.parse(JSON.stringify(json));
    }

    updateFrom(entity) {
        if (entity) {
            for (var attributeKey of this.attributeKeys) {
                this[attributeKey] = entity[attributeKey];
            }
        }
    }

    observe() {
        this.observable = new Observable((subscriber) => {
            this.subscribers.push(subscriber);
        });
        return this.observable;
    }
}